export default "__VITE_ASSET__49d479df__"